export { default as VictoryScatter } from "./victory-scatter";